/**
 * @packageDocumentation
 *
 * This module initializes the Card Lint Selector component and Radio Button component.
 *
 */
import {
	defineCardLintSelectorComponent,
	defineRadioButtonComponent,
	initCardConfiguratorV3,
} from "@nx-paeonia/feature-product-configurator";

defineCardLintSelectorComponent();
defineRadioButtonComponent();

initCardConfiguratorV3();
